import * as React from 'react';
import { PageLayout } from '../../components/PageLayout';
import { HeaderContainer } from '../Header';
import { SearchResultContainer } from '../SearchResult';
import { PaginationContainer } from '../Pagination';

export function PageContainer(): React.JSX.Element {
  return (
    <PageLayout
      header={<HeaderContainer />}
      searchResult={<SearchResultContainer />}
      pagination={<PaginationContainer />}
    />
  );
}
